export var UnsubscribedMarketingType = /*#__PURE__*/ function(UnsubscribedMarketingType) {
    UnsubscribedMarketingType["UNSUBSCRIBED_MARKETING_TYPE_UNKNOWN"] = "UNSUBSCRIBED_MARKETING_TYPE_UNKNOWN";
    UnsubscribedMarketingType["FAIRE_SENT"] = "FAIRE_SENT";
    UnsubscribedMarketingType["BRAND_CRM_SENT"] = "BRAND_CRM_SENT";
    return UnsubscribedMarketingType;
}({});
